import React, {Component} from 'react';

import './nav.css';

class Nav extends Component {
  render() {
    return(
      <div className='nav'>
        <h1 className='navText'>DASH</h1>
        <div className='logButton' onMouseDown={() => window.open('https://docs.google.com/document/d/1uXt_dO6zHyIOvsupBueB5VCvcKp1sQ70hzoEgauem88/edit?usp=sharing')}>View Devlog</div>
      </div>
    )
  }
}

export default Nav;